import { asyncModule } from '../../utils/async-module';
import { asyncPreactWidget } from '../../utils/async-preact-widget';
import * as JSModules from '../../components/modules';
import * as preactWidgets from '../../preact/widgets';
import { landToElement } from '../../utils/land-to-element';

export const asyncScrollToTop = () => {
  const $elements = document.querySelectorAll('.j-scroll-to-top');
  if ($elements.length) {
    const { start, getInit, error } = asyncModule(JSModules.scrollToTopModule);
    start();
    import('../../components/scroll-to-top/scroll-to-top').then(getInit($elements)).catch(error);
  }
};

export const asyncReadingProgressBar = () => {
  const $paragraphs = document.querySelectorAll('.j-article-section p');
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.readingProgressBarModule);
  if (shouldInit($paragraphs)) {
    start();
    import('../../components/reading-progress-bar/reading-progress-bar').then(getInit()).catch(error);
  }
};

export const asyncPageRefresh = () => {
  const { shouldInit, start, getInit, error } = asyncModule(JSModules.pageRefreshModule);
  if (shouldInit()) {
    start();
    import('../../components/page-refresh/page-refresh').then(getInit()).catch(error);
  }
};

export const asyncLandToElement = () => {
  const responsiveOffset = landToElement.get()?.responsiveOffset;
  const elementIdToLand = landToElement.get()?.elementId;
  const fallbackElementClassnameToLand = landToElement.get()?.fallbackElementClassname;
  const tabIdToLand = landToElement.get()?.tabId;
  if (elementIdToLand) {
    const { start, getInit, error } = asyncModule(JSModules.landToElementModule);
    start();
    import('../../components/land-to-element/land-to-element')
      .then(getInit({ responsiveOffset, elementIdToLand, fallbackElementClassnameToLand, tabIdToLand }))
      .catch(error);
  }
};

export const asyncTabSwitch = () => {
  const $element = document.querySelector('.j-hp-tabs');
  if ($element) {
    const { start, getInit, error } = asyncModule(JSModules.hpTabSwitchModule);
    start();
    import('../../components/homepage-tabs/homepage-tabs').then(getInit($element)).catch(error);
  }
};

export const asyncSetOfCardsInfinite = () => {
  const { isOnPage, start, hydrate, error } = asyncPreactWidget(preactWidgets.setOfCardsInfinite);
  if (isOnPage()) {
    start();
    import(`../../preact/widgets/set-of-cards-infinite`).then(hydrate).catch(error);
  }
};
